import React, { Component } from 'react';
import cx from 'classnames';
import { Button, Card, CardBody, Spinner } from 'reactstrap';
import sctheme from 'app/styles/sctheme';

export class Loading extends Component {
  static defaultProps = {
    width: 75,
    height: 75,
    color: sctheme.blues.primary
  };

  render() {
    const { color, width } = this.props;
    const isCompact = width && width <= 30;

    return (
      <div
        className="d-flex h-100 w-100 justify-content-center align-items-center"
        style={isCompact ? undefined : { minHeight: '60vh' }}
      >
        <Spinner size={isCompact ? 'sm' : undefined} style={{ color }} children="" />
      </div>
    );
  }
}

export function LoadingCard({ className, message = null }) {
  return (
    <Card className={className}>
      <CardBody className="d-flex align-items-center p-5 flex-column justify-content-center">
        <Loading />
        {message ? <div>{message}</div> : null}
      </CardBody>
    </Card>
  );
}

export function LoadingButton(props) {
  const { children, className, isLoading, ...restProps } = props;
  return (
    <Button className={cx(className, 'd-flex justify-content-center')} {...restProps}>
      {children}
      {isLoading && <Loading color={sctheme.white} height={25} width={25} />}
    </Button>
  );
}

export default Loading;
